export default "__VITE_ASSET__BX9LP$K3__"